import { useEffect, useState } from 'react';
import Sidebar from '../organisms/Sidebar';
import TopBar from '../organisms/TopBar';
import BottomNav from '../organisms/BottomNav';

function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Só enquanto esta tela (com BottomNav escuro) está montada o body deve
  // ficar escuro no celular — a tela de login usa o mesmo body e é clara.
  useEffect(() => {
    document.body.classList.add('app-shell-active');
    return () => document.body.classList.remove('app-shell-active');
  }, []);

  return (
    <div className="d-flex app-shell" style={{ overflow: 'hidden' }}>
      <Sidebar show={sidebarOpen} onHide={() => setSidebarOpen(false)} />
      <div className="d-flex flex-column flex-grow-1 overflow-hidden">
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
        <main
          className="flex-grow-1 overflow-auto p-4"
          style={{ backgroundColor: '#f8f8fc' }}
        >
          {children}
        </main>
        <BottomNav />
      </div>
    </div>
  );
}

export default AdminLayout;
